import React from "react";
import TechnicalServicesRedesign from "../redesign/TechnicalServicesRedesign";

const TechnicalServices = () => {
  return <TechnicalServicesRedesign />;
};

export default TechnicalServices;
